import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL

export const tripApi = async (data) => {
  let url = ''
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1
  if (data?.id) {
    url = `${env}${API_ENDPOINT.Trip.api + '/' + data?.id}`
  } else {
    url = `${env}${API_ENDPOINT.Trip.api + '?type=' + data?.type + "&status=" + data?.status + "&dateFrom=" + (data?.dateFrom ? data?.dateFrom : '') + "&dateTo=" + (data?.dateTo ? data?.dateTo : '') + "&page=" + page + "&pageSize=" + data.pageSize + "&search=" + (data?.search ? data?.search : "")}`
  }
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}

export const shareTripApi = async (data) => {
  const { tripId, cid } = data;
  const res = await requestInstance.get(
    `${env}${API_ENDPOINT.Trip.shareTripApi}?tripId=${tripId}&cid=${cid}`,
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}